import {ChildEntity, Column} from "typeorm";
import {Incident} from "@/modules/match/entity/Incident";
import {CardEnum} from "@/modules/match/enums";
import CardIncidentComponent from '@/modules/match/components/CardIncident.vue';
import CardIncidentLiveComponent from '@/modules/match/components/live-incident/CardIncident.vue';
import {Component, ShallowRef} from "vue";

@ChildEntity()
export class CardIncident extends Incident {
  @Column({type: 'varchar', enum: CardEnum})
  card: CardEnum;

  get component(): ShallowRef<Component> {
    return shallowRef(CardIncidentComponent);
  }

  get liveComponent(): ShallowRef<Component> {
    return shallowRef(CardIncidentLiveComponent);
  }
}
